import { applicationFeesApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_CIC_FEE_REASONS_ACTION_TYPE_V2 = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/cicFeeReasonsV2`,
  {
    GET_LOAN_CIC_FEE_REASONS: 'GET_LOAN_CIC_FEE_REASONS',
    EDIT_LOAN_CIC_FEE_REASONS: 'EDIT_LOAN_CIC_FEE_REASONS',
  },
);

const cureBaselineSchema = new schema.Entity('data', {}, { idAttribute: 'feeTypeId' });

export const getLoanCicFeeReasonsActionV2 = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationFeesApi.getLoanFeesReasonsV2(params);

  return dispatch({
    type: LOAN_CIC_FEE_REASONS_ACTION_TYPE_V2.GET_LOAN_CIC_FEE_REASONS,
    payload: {
      ...data,
      cureBaseline: data.cureBaseline
        ? normalize(data.cureBaseline.fees, [cureBaselineSchema]).entities.data
        : null,
    },
  });
});

export const editLoanFeesPatchAction = params => async dispatch => {
  const { data } = await applicationFeesApi.editLoanFeesPatch(params);

  return dispatch({
    type: LOAN_CIC_FEE_REASONS_ACTION_TYPE_V2.EDIT_LOAN_CIC_FEE_REASONS,
    payload: data,
  });
};
